import { Component, OnInit, ViewChild } from '@angular/core';
import {LookupService} from '../share/services/lookup/lookup.service';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {faBan, faCircleCheck, faHistory} from '@fortawesome/free-solid-svg-icons';
import {ConfirmationPopupComponent} from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from 'src/environments/environment';
import {APPTYPES} from '../share/constants/common-constants';
import {CommonService} from '../share/services/common/common.service';
import { Router } from '@angular/router';
import { DepartmentsListComponent } from './departments-list/departments-list.component';
import { WorkflowListComponent } from './workflow-list/workflow-list.component';
import { SupportingDocumentTypeListComponent } from './supporting-document-type-list/supporting-document-type-list.component';
import { StorageKeys } from '../share/enums/storage.enum';

@Component({
    selector: 'app-lookup',
    templateUrl: './lookup.component.html',
    styleUrl: './lookup.component.scss',
    standalone: false
})
export class LookupComponent implements OnInit {
  @ViewChild(DepartmentsListComponent) departmentsListComponent : DepartmentsListComponent;
  @ViewChild(WorkflowListComponent) workflowListComponent : WorkflowListComponent;
  @ViewChild(SupportingDocumentTypeListComponent) supportingDocumentTypeListComponent : SupportingDocumentTypeListComponent;
  verifyLoader: boolean = false;
  metadataList: any;
  isLookup: boolean = false;
  isSelectRadio: boolean = false;
  isSelectCheckbox: boolean = false;
  data: any;
  addedFields: any[] = [];
  errorMessage: string;
  tabvalue: any = 'documenttype';
  selfDetails: any = {};
  editItem: any = null;
  fieldType: string = '';
  isSuccessToster: boolean = false;
  uploadErrorMessage: string = '';
  isToasterMessage: boolean =false;
  isdocumenttype: any;
  documentType: any = null;
  isModule: any;
  moduleItem: any;
  companyDoc: any;
  fieldHistoryList: any[] = [];
  label: any;
  iscontracttype: any;
  isrecordtype: any;
  isEnvTypeClms: boolean = false;
  masterData: any;
  isOpenAddMasterDataPanel: boolean = false
  isLoadRecords: boolean = false
  docId: any;
  envType = environment?.envType || 'SDEX';
  appType = APPTYPES;
  message : string =" ";
  hasEditAccess : boolean;
  activeUrl : string = '';
  openDepartmentPanel : boolean = false;
  totalRecords: number = 0;
  openWorkflowPanel : boolean = false;
  openSupportingDocumentTypePanel : boolean = false;


  public readonly faEdit = faEdit;
  protected faBan = faBan;
  protected faCircleCheck = faCircleCheck;
  protected faHistory = faHistory;

  constructor(
    private readonly lookupService: LookupService,
    private readonly storageService: StorageService,
    private readonly modal: NgbModal,
    public commonService    : CommonService,
    public router: Router

  ) { }

  ngOnInit(): void {
    this.selfDetails = this.storageService.getDataFromLocalStorage('selfDetails');
    this.activeUrl = this.router.url;
    const roles = this.selfDetails?.assignedTo?.[0]?.roles || [];
    const allPermissions = roles.flatMap((role: any) => role?.permissions || []);
    const hasWorkflowAccess = allPermissions.some(
      (permission: any) =>
        permission?.module === 'workflow' &&
        Object.values(permission?.subPermissions || {}).some(Boolean)
    );
    const hasDocumentAccess = allPermissions.some(
      (permission: any) =>
        permission?.module === 'document' &&
        Object.values(permission?.subPermissions || {}).some(Boolean)
    );
    const companyPrefs = this.storageService.getDataFromSessionStorage(StorageKeys.PREFERENCES)
      || this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES);
    const isInvoiceTrackingEnabled = !!companyPrefs?.invoiceTrackingSystem?.enabled;
    if (isInvoiceTrackingEnabled) {
      this.tabvalue = 'departments';
    } else if (hasWorkflowAccess && hasDocumentAccess) {
      this.tabvalue = 'documenttype';
    } else if (hasWorkflowAccess) {
      this.tabvalue = 'departments';
    } else {
      this.tabvalue = 'documenttype';
    }
  }

  addModule() {
    document.body.style.overflow = 'hidden';
    this.isModule = new Date();
  }

  addLookup() {
    document.body.style.overflow = 'hidden';
    this.isLookup = true;
  }

  AddDocumentType() {
    document.body.style.overflow = 'hidden';
    this.isdocumenttype = new Date();
    if(this.tabvalue === 'recordtype' || this.tabvalue === 'contracttype') {
      this.isOpenAddMasterDataPanel = true
    }
    else if (this.tabvalue === 'departments') {
      this.openDepartmentPanel = true;
    }
    else if (this.tabvalue === 'workflows') {
      this.openWorkflowPanel = true;
    }
    else if (this.tabvalue === 'supportingdocumenttype') {
      this.openSupportingDocumentTypePanel = true;
    }
  }

  onTabselect(value: any) {
    if (value === this.tabvalue) {
      return;
    }
    this.tabvalue = value;
    if(value === 'recordtype' || value === 'contracttype'){
      this.getMasterData();
    }
  }

  onCloseIconClick(value: any) {
    document.body.style.overflow = '';
    this.isLookup = false;
    this.isModule = false;
    this.isSelectRadio = false;
    this.isSelectCheckbox = false;
    this.editItem = null;
    this.addedFields = [];
    this.verifyLoader = false;
    this.isdocumenttype = false;
    if (value) {
      this.getMetadataByDocId(this.docId);
    }
  }

  getMetadataList() {
    this.isLoadRecords = true;
    this.lookupService.getMetadatalist(this.selfDetails?.rootCompany)?.subscribe({
      next: (res) => {
        if (res.success) {
          this.isLoadRecords = false;
          this.metadataList = res.data;
        }
      }, error: (err) => {
        this.isLoadRecords = false;
        this.errorMessage = err.error?.error?.message;
      }
    })
  }

  editLookup(item: any) {
    document.body.style.overflow = 'hidden';
    if (item.status === 'Disabled') {
      this.isSuccessToster = true;
      this.uploadErrorMessage = 'Only enabled status can be edited!';
    } else {
      this.editItem = item;
      this.isLookup = true;
    }
  }

  closeToster(value: any) {
    this.isSuccessToster = true;
    this.uploadErrorMessage = '';
  }

  disableMetadata(value: any, status: string) {
    let msg = status === 'Enabled' ? 'Disable' : 'Enable';
    let Status = status === 'Enabled' ? 'Disabled' : 'Enabled';
    const dialogRef = this.modal.open(ConfirmationPopupComponent, {
      keyboard: false,
      backdrop: 'static',
    })
    dialogRef.componentInstance.message = `Are you sure to ${msg} "${value.label}"`;
    dialogRef.componentInstance.header = `${msg} Metadata`;
    dialogRef.componentInstance.lableName = msg;
    dialogRef.result?.then((result) => {

      if (result && value._id) {
        if (status == 'Enabled') {
          value.enabledLoader = true;
        }
        if (status == 'Disable') {
          value.disableLoader = true;
        }
       this.disabledMetadata(value, Status)

      }
    });
  }

  disabledMetadata(value: any, Status: any) {
    this.lookupService.disableMetadata(value._id).subscribe({
      next: (res) => {
        if (res.success) {
          this.getMetadataByDocId(this.docId);
          value.disableLoader = false;
          value.enabledLoader = false;
          this.isToasterMessage =true;
          this.uploadErrorMessage =`Metadata ${Status.toLowerCase()} successfully!`;
        } else {
          this.errorMessage = res.message;
        }
      },
      error: (err) => {
        this.errorMessage = err.error?.error?.message;
        value.disableLoader = false;
        value.enabledLoader = false;
      }
    });
  }

  editModuleItem(data: any) {
    this.isModule = true;
    this.moduleItem = data
  }

  viewDocmentType(value: any) {
    this.docId = value._id;
    this.tabvalue = 'documentmetadata';
    this.companyDoc = value;
    this.getMetadataByDocId(value._id);
    this.hasEditAccess = this.checkEditAccess(value);
  }

  checkEditAccess(docType: any){
    if (!this.commonService.hasAllowedAction()) {
      return false;
    }
    return docType?.visibleTo.includes(this.selfDetails?.company);
  }

  getMetadataByDocId(id: any) {
    this.lookupService.getMetadataByDocId(id)?.subscribe({
      next: (res) => {
        if (res.success) {
          this.metadataList = res.data;
        }
      }, error: (err) => {
        this.errorMessage = err.error?.error?.message;
      }
    })
  }

  getFieldHistory(data: any, contant: any) {
    this.label = data.label;
    this.lookupService.getFieldHistory(data?._id).subscribe({
      next: (res) => {
        if (res.success) {
          this.fieldHistoryList = res.data
          const dialogRef = this.modal.open(contant, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg',
            // centered: true,
          })
          if(dialogRef.result.then){
          dialogRef.result.then((result) => {//close
          }, (reason) => {

          });
        }
      }
      }, error: (err) => {
        this.errorMessage = err.error?.error?.message;
      }
    })
  }

  gotoBack() {
    this.tabvalue = 'documenttype';
    this.companyDoc = undefined;
  }

  getMasterData() {
    this.isLoadRecords = true;
    this.lookupService.getMasterList({
      masterType: this.tabvalue === 'contracttype' ? 'contractType' : 'recordType'
    })?.subscribe((res: any) => {
      this.isLoadRecords = false;
      this.masterData = res.data;
    })
  }

  openAddClmsMasterDataType() {
    document.body.style.overflow = '';
    this.isOpenAddMasterDataPanel = true
  }

  closeAddClmsMasterDataType(isSave: boolean) {
    document.body.style.overflow = '';
    if (isSave) {
      this.getMasterData();
    }
    this.isOpenAddMasterDataPanel = false
  }

  updateContactTypesData(event: any) {
    this.getMasterData();
  }

  onSubmit(event: any) {
    if (event.success) {
      this.isToasterMessage = true;
      this.uploadErrorMessage = event.message;
    }
  }

  closeDepartmentPanel() {
    document.body.style.overflow = '';
    this.openDepartmentPanel = false;
  }

  successTosterFromAddDepartmentComponent(message: any) {
    this.isToasterMessage = true;
    this.uploadErrorMessage = message;
    this.departmentsListComponent.getDepartmentsList(0);
    this.departmentsListComponent.getDepartmentCount();
  }

  closingToster(value:any){
    this.isSuccessToster=value;
    this.isToasterMessage=value;
    this.uploadErrorMessage="";
  }

  closeWorkflowPanel(event: any) {
    document.body.style.overflow = '';
    this.openWorkflowPanel=false;
    if(event.isSuccess){
      this.workflowListComponent.getWorkflowCount();
      this.workflowListComponent.getWorkflowList();
      this.onSubmit({success:true, message:"Workflow is added succesfully"})
    }
  }

  closeSupportingDocumentTypePanel() {
    document.body.style.overflow = '';
    this.openSupportingDocumentTypePanel = false;
  }

  successTosterFromAddSupportingDocumentTypeComponent(message: any) {
    document.body.style.overflow = '';
    this.openSupportingDocumentTypePanel = false;
    this.isToasterMessage = true;
    this.uploadErrorMessage = message;
    this.supportingDocumentTypeListComponent.getSupportingDocumentTypeList(0);
  }

}


